import "core-js/modules/es.array.push.js";
import EmdEnumValueListView from "@/views/manager/EmdEnumValueListView.vue";
import SiteNavListView from "@/views/site/SiteNavListView.vue";
import SiteKeywordsListView from "@/views/site/SiteKeywordsListView.vue";
import SiteFriendLinkView from "@/views/site/SiteFriendLinkView.vue";
import SiteFooterView from "@/views/site/SiteFooterView.vue";
import SitePageView from "@/views/site/SitePageView.vue";
import BannerConfigView from "@/views/site/BannerConfigView.vue";
import SitePageStatisticView from "@/views/site/SitePageStatisticView.vue";
import SchoolListView from "@/views/site/SchoolListView.vue";
import HotSearchView from "@/views/site/HotSearchView.vue";
import SiteCountdownArticleView from "@/views/site/SiteCountdownArticleView.vue";
import FriendNoticeView from "@/views/site/FriendNoticeView.vue";
import RegionView from "@/views/site/RegionView.vue";
export default {
  name: "PcSiteView",
  components: {
    RegionView,
    FriendNoticeView,
    SiteCountdownArticleView,
    HotSearchView,
    SchoolListView,
    BannerConfigView,
    SitePageView,
    SitePageStatisticView,
    SiteFooterView,
    SiteFriendLinkView,
    SiteKeywordsListView,
    SiteNavListView,
    EmdEnumValueListView
  },
  data() {
    return {
      curNav: this.$route.params.tab,
      navs: ['站点管理', '导航配置', '关键词管理', '文章结尾管理', '友情链接', '文章管理', '轮播图管理', '文章分布统计', '文章回收站', '学校列表', '热搜管理', '倒计时文章', '文章温馨提示', '区域配置']
    };
  },
  watch: {
    curNav(cur) {
      this.$router.push('/pc/site/' + cur);
    }
  },
  methods: {
    configSite(data) {
      this.$router.push('/site/config/' + data.id);
    },
    init() {}
  },
  mounted() {
    this.init();
  }
};